<template>
  <div class="content-fixed">
    <!-- <div class="container pd-x-0 pd-lg-x-30 pd-lg-y-40 text-center">
      <h4>Дүр*ээ сонгоно уу? *Хуучин</h4>
      <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
              <div class="card">
                <router-link :to="'/learn/course/115'" role="button" class="card-body pd-y-50">
                  
                      <p class="card-text tx-18">
                          <feather type="server"></feather>
                          <span class="mg-l-10">Админ</span>
                      </p>
                  
                </router-link>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
              <div class="card">
                <router-link :to="{name: 'lmsDashboard'}" role="button" class="card-body pd-y-50">
                
                    <p class="card-text tx-18">
                        <feather type="briefcase"></feather>
                        <span class="mg-l-10">Багш</span>
                    </p>
                
                </router-link>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
              <div class="card">
                <router-link :to="({name: 'lmsParticipant'})" role="button" class="card-body pd-y-50">
                  <p class="card-text tx-18">
                        <feather type="book"></feather>
                        <span class="mg-l-10">Сурагч</span>
                    </p>
                </router-link>
            </div>
          </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { hasOneOf } from "@/libs/tools";

export default {
  components: {},
  mounted() {},
  methods: {
    hasPermission(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    }
  }
};
</script>

<style></style>
